'use client';

import Lottie from 'lottie-react';

import bookAnimation from './book.json';

export function Loading() {
  return <Lottie animationData={bookAnimation} />;
}
